import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePlatformAdmin } from '@/contexts/PlatformAdminContext';

interface PlatformAdminInterceptorProps {
  children: React.ReactNode;
}

export function PlatformAdminInterceptor({ children }: PlatformAdminInterceptorProps) {
  const { isPlatformAdmin, validationState } = usePlatformAdmin();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only act if explicitly valid (not unknown)
    if (isPlatformAdmin && validationState === 'valid') {
      // Check if platform admin is trying to access regular tenant routes
      const tenantRoutes = ['/conversations', '/dashboard', '/billing'];
      const currentPath = location.pathname;
      
      if (tenantRoutes.some(route => currentPath.startsWith(route))) {
        // Redirect to tenant selection for conversations
        if (currentPath === '/conversations') {
          navigate('/platform-admin/tenant/conversations', { replace: true });
          return;
        }
        
        // For other tenant routes, redirect to platform admin dashboard
        navigate('/platform-admin', { replace: true });
        return;
      }
    }
  }, [isPlatformAdmin, location.pathname, navigate]);

  return <>{children}</>;
}